import {createContext, useContext} from "react";
import useCart from "../components/Hooks/useCart";

const CartContext = createContext({
    cart: null,
    addStockProductToCart: async () => {},
    addStockProductSetToCart: async () => {},
    addProductToBaseOrder: async () => {},
    updateBaseOrderItem: async () => {},
    updateStockItem: async () => {},
    updateStockSetItem: async () => {},
    deleteBaseOrderItem: async () => {},
    removeStockItemFromCart: async () => {},
    removeStockSetItemFromCart: async () => {},
    updateCartItem: async () => {},
    clearCart: async () => {},
    setInitCart: async () => {},
})

export const CartContextProvider = ({children}) => {
    const cart = useCart();

    return <CartContext.Provider value={cart}>{children}</CartContext.Provider>
}

export const useCartContext = () => useContext(CartContext)